import React from "react";
import EditRoles from "./edit-roles";

const EditRolesComponent = ({
  accountId,
  roleRates,
  tags,
  isPartner
}) => {
  return (
    <EditRoles
      accountId={accountId}
      roleRates={roleRates}
      tags={tags}
      isPartner={isPartner}
    />
  );
};

export default EditRolesComponent;
